module.exports = __webpack_public_path__ + "static/Education2-eee84e83b6621a456af97619ef86d30e.png";